<template>
  <div
    class="asset_presenter"
    v-if="content_asset && content_asset.type == 'RenderableTestimonial'"
  >
    <TestimonialBasic
      :renderable-testimonial="content_asset"
      :account="account"
      renderAsList
      :showLogos="showLogos"
      v-if="renderAsList"
    ></TestimonialBasic>
    <TestimonialSocial191
      :renderableTestimonial="content_asset"
      :shape="shape"
      :show_all_pages="show_all_pages"
      :page="page"
      :account="account"
      :class="{ crimp }"
      v-else-if="style == 'styled'"
    />
    <TestimonialBranded
      :renderableTestimonial="content_asset"
      :backgroundColorOption="background_color_option"
      :account="account"
      :class="{ crimp }"
      v-else-if="style == 'branded'"
    />
    <TestimonialBasic
      :renderable-testimonial="content_asset"
      :shape="shape"
      :showAllPages="show_all_pages"
      :page="page"
      :account="account"
      v-else-if="style == 'basic'"
    />
    <TestimonialCustom
      :renderable-testimonial="content_asset"
      :shape="shape"
      :show_all_pages="show_all_pages"
      :page="page"
      :account="account"
      :theme="theme.data"
      :class="{ crimp }"
      v-else-if="style.match(/^custom_v1/)"
    />
    <TestimonialSvg
      :renderable-testimonial="content_asset"
      :theme="theme"
      :class="{ crimp }"
      v-else-if="style.match(/^custom_v2/)"
    />
  </div>

  <div class="asset_presenter" v-else-if="content_asset && content_asset.type == 'ChartAsset'">
    <BarChartBasic
      :content-asset="content_asset"
      :account="account"
      renderAsList
      :showLogos="showLogos"
      v-if="renderAsList"
    />
    <BarChartBasic
      :content-asset="content_asset"
      :chartColorOption="stat_color_option"
      :account="account"
      :class="{ crimp }"
      v-else-if="design == 'basic'"
    />
    <BarChartBranded
      :content-asset="content_asset"
      :chartColorOption="stat_color_option"
      :backgroundColorOption="background_color_option"
      :class="{ crimp }"
      v-else-if="design == 'branded'"
    />
  </div>

  <div class="asset_presenter" v-else-if="content_asset && content_asset.type == 'StatAsset'">
    <StatBasic
      :content-asset="content_asset"
      :account="account"
      renderAsList
      :showLogos="showLogos"
      v-if="renderAsList"
    ></StatBasic>
    <StatBasic
      :content-asset="content_asset"
      :statColorOption="stat_color_option"
      :account="account"
      :class="{ crimp }"
      v-else-if="design == 'basic'"
    />
    <StatBranded
      :content-asset="content_asset"
      :statColorOption="stat_color_option"
      :backgroundColorOption="background_color_option"
      :class="{ crimp }"
      v-else-if="design == 'branded'"
    />
  </div>

  <div class="asset_presenter" v-else-if="content_asset && content_asset.type == 'SurveySummary'">
    <SurveySummary :content-asset="content_asset" :account="content_asset.account" />
  </div>

  <div class="asset_presenter" v-else-if="content_asset && content_asset.type == 'MatrixxChart'">
    <MatrixxChartBasic
      :matrixxChart="content_asset"
      :account="account"
      renderAsList
      :showLogos="showLogos"
      v-if="renderAsList"
    ></MatrixxChartBasic>
    <MatrixxChartBranded
      :matrixxChart="content_asset"
      :account="content_asset.account"
      :statColorOption="stat_color_option"
      :backgroundColorOption="background_color_option"
      :class="{ crimp }"
      v-else-if="style == 'branded'"
    />
    <MatrixxChartBasic
      :matrixxChart="content_asset"
      :class="{ crimp }"
      :statColorOption="stat_color_option"
      :account="content_asset.account"
      v-else
    />
  </div>

  <div
    class="asset_presenter"
    v-else-if="content_asset && content_asset.type == 'CustomerSpotlight'"
  >
    <BasicAssetCard
      v-if="renderAsList"
      :content_asset="content_asset"
      :showLogos="showLogos"
    ></BasicAssetCard>

    <CustomerSpotlight v-else :customer_spotlight="content_asset" :account="account" />
  </div>

  <div class="asset_presenter" v-else-if="content_asset && content_asset.type == 'VideoLinkAsset'">
    <VideoLinkAsset
      renderAsList
      v-if="renderAsList"
      :video-link-asset="content_asset"
      :account="account"
      :showLogos="showLogos"
    />
    <VideoLinkAsset v-else :video-link-asset="content_asset" :account="account" />
  </div>

  <div class="asset_presenter" v-else-if="content_asset && content_asset.type == 'FileAsset'">
    <FileAsset
      v-if="renderAsList"
      :file-asset="content_asset"
      :account="account"
      renderAsList
      :showLogos="showLogos"
    />
    <FileAsset v-else :file-asset="content_asset" :account="account" />
  </div>

  <div
    class="asset_presenter"
    v-else-if="content_asset && content_asset.type == 'SurveySpotlightAsset'"
  >
    <BasicAssetCard
      v-if="renderAsList"
      :content_asset="content_asset"
      :showLogos="showLogos"
    ></BasicAssetCard>
    <SurveySpotlight v-else :content_asset="content_asset" :horizontal="true" />
  </div>

  <div class="asset_presenter" v-else-if="content_asset && content_asset.type == 'CaseStudy'">
    <BasicAssetCard
      v-if="renderAsList"
      :content_asset="content_asset"
      :showLogos="showLogos"
    ></BasicAssetCard>
    <CaseStudy v-else :case-study="content_asset" :account="account" />
  </div>

  <div class="asset_presenter" v-else-if="content_asset && content_asset.type == 'SocialPost'">
    <SocialPost
      :content-asset="content_asset"
      :account="account"
      :renderAsList="renderAsList"
      :showLogos="showLogos"
      :scrollable="socialPostScrollable"
    />
  </div>

  <div v-else-if="content_asset && content_asset.type == 'CustomerPageAsset'">
    <CustomerPageAsset :customer-page-asset="content_asset" :account="account" />
  </div>
</template>
<script lang="ts">
import StatBasic from '@components/StatBasic.vue'
import StatBranded from '@components/StatBranded.vue'
import TestimonialSocial191 from '@components/TestimonialSocial191.vue'
import TestimonialBasic from '@components/TestimonialBasic.vue'
import TestimonialBranded from '@components/TestimonialBranded.vue'
import TestimonialCustom from '@components/TestimonialCustom.vue'
import TestimonialSvg from '@components/TestimonialSvg.vue'
import BarChartBasic from '@components/BarChartBasic.vue'
import BarChartBranded from '@components/BarChartBranded.vue'
import CustomerSpotlight from '@components/CustomerSpotlight.vue'
import SurveySpotlight from '@components/SurveySpotlight.vue'
import MatrixxChartBasic from '@components/MatrixxChartBasic.vue'
import MatrixxChartBranded from '@components/MatrixxChartBranded.vue'
import SurveySummary from '@components/SurveySummary.vue'
import CaseStudy from '@components/CaseStudy.vue'
import BasicAssetCard from '@components/BasicAssetCard.vue'
import CustomerPageAsset from '@components/CustomerPageAsset.vue'
import VideoLinkAsset from '@components/VideoLinkAsset.vue'
import FileAsset from '@components/FileAsset.vue'
import SocialPost from '@components/SocialPost.vue'

export default {
  components: {
    BarChartBranded,
    StatBranded,
    StatBasic,
    TestimonialBasic,
    TestimonialSocial191,
    TestimonialBranded,
    TestimonialCustom,
    TestimonialSvg,
    CustomerSpotlight,
    SurveySpotlight,
    MatrixxChartBasic,
    BarChartBasic,
    MatrixxChartBranded,
    SurveySummary,
    CaseStudy,
    BasicAssetCard,
    CustomerPageAsset,
    VideoLinkAsset,
    FileAsset,
    SocialPost,
  },
  props: {
    content_asset: {
      type: Object,
      required: true,
    },
    shape: { type: String },
    show_all_pages: {
      type: Boolean,
      default: false,
    },
    page: {
      type: Number,
      default: 1,
    },

    // design is used to determine the style of the asset
    // it is used by StatAsset, Testimonial, and BarChart
    // values can be 'basic' or 'branded', or for testimonials, it could be 'custom:123' (where 123 is the theme id)
    design: {
      type: String,
      default: 'basic',
    },

    // backgroundColor is UNUSED
    backgroundColor: {
      type: String,
    },
    account: { type: Object },

    // theme is actually an OBJECT that contains the theme information
    // it is passed to the TestimonialCustom component
    // see getTestimonialThemes in api.js for more information
    theme: { type: Object },

    // stat_color_option is used by StatAsset, BarChart, and MatrixxChart
    // it is passed to statColorOption prop
    // its value can be 'primary' or 'secondary'
    stat_color_option: { type: String },

    // background_color_option is a string used by Branded assets - TestimonialBranded, StatBranded, BarChartBranded, and MatrixxChartBranded
    // values can be 'dark', 'white', 'primary', 'secondary', or 'both'
    background_color_option: { type: String },

    // This is mostly a legacy thing, before RenderableTestimonials/
    // all assets were capped to 624px.
    // We turned crimp into a prop so that this can be turned off/on when needed.
    // GDA March 2025 update - this is now only used by the `EviAssetPreviewer` component
    // https://userevidence.slack.com/archives/C050WUX3W95/p1737559525925389
    crimp: { type: Boolean, default: true },

    /**
     * This is used to determine if the asset should be rendered as a Preview card.
     * Places like Evi bot and the Assets#index page need this type of rendering.
     */
    renderAsList: {
      type: Boolean,
      default: false,
    },

    /**
     * Controls whether logos should be displayed in the asset components
     */
    showLogos: {
      type: Boolean,
      default: true,
    },

    /**
     * Controls whether social media iframes should be scrollable
     */
    socialPostScrollable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    // style is only used for testmonials.
    // it looks at
    style() {
      if (this.design.includes('branded_')) {
        return 'branded'
      }

      return this.design
    },
  },
}
</script>

<style lang="sass" scoped>
.crimp
  width: 624px !important
.customer_spotlight_multi_page_presenter
  display: inline-block
  width: 99999px
</style>
